export default __webpack_public_path__ + "static/media/policy.b44153fb.svg";